import { countryData } from 'src/utils/countryData';
import { useStore } from 'src/utils/v2_helper/common';
import { computed, ref } from 'vue';

export function useChooseCountry() {
  const store = useStore();

  const searchText = ref('');
  const chooseCountryVisible = ref(false);

  const countryCode = computed(() => store.state.Menu.countryCode);
  const countryName = computed(() => store.state.Menu.countryName);
  const showCountry = computed(() => {
    if (!searchText.value) {
      return countryData;
    }
    return countryData.filter(
      (item) =>
        item.value.includes(`${searchText.value}`) ||
        item.name
          .toLocaleLowerCase()
          .includes(searchText.value.toLocaleLowerCase()) ||
        item.key
          .toLocaleLowerCase()
          .includes(searchText.value.toLocaleLowerCase()),
    );
  });
  function changeCountry({ value, name }) {
    store.commit('Menu/updateCountryName', name);
    store.commit('Menu/updateCountryCode', value);
    setTimeout(() => {
      chooseCountryVisible.value = false;
    }, 300);
  }
  return { searchText, countryCode, countryName, showCountry, changeCountry, chooseCountryVisible }
}
